import {
  Breadcrumb,
  Col,
  ConfigProvider,
  Flex,
  Row,
  Skeleton,
  Space,
  Spin,
  Table,
  Typography,
} from 'antd';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import GoogleMap from './GoogleMapRouteTracking';
import FilterEmployeeRouteTracking from './FilterEmployeeRouteTracking';
import TextCustom from 'components/Text/TextCustom';
import TableEmployeeRouteTracking from './TableEmployeeRouteTracking';
import { useTitle } from 'contexts/TitleProvider';
import { Button, ButtonFilter } from 'components';
import { IconLoading } from 'assets/svg';
import { useUser } from 'contexts/UserProvider';
import { useMutation } from '@tanstack/react-query';
import { RouteTrackingApi } from 'apis/RouteTrackingApi';
import dayjs from 'dayjs';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import useQueryParam from 'hooks/useQueryPrams';
import { useNavigate } from 'react-router-dom';
import path from 'routes/Path';
import formatNumber from 'utils/constants/functions';
import { dataTestLocationCustomebyTeamSale } from 'mock/dataRouteTracking';

const EmployeeRouteTracking = () => {
  const { setBreadcrumb, setTitle } = useTitle();
  const { user } = useUser();
  const { Text } = Typography;
  const navigate = useNavigate();

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const [isOpen, setIsOpen] = useState(false);
  const [dataFilter, setDataFilter] = useState<any>({});
  const [salePlanningId, setSalePlanningId] = useState<any>(null);
  const [locationTeams, setLocationTeams] = useState<any>(null);
  const [locationCustoms, setLocationCustoms] = useState<any>(null);
  const [isShowMapCustom, setIsShowMapCustom] = useState(false);

  const defaultFilter = useMemo(() => {
    const userAny = user as any;
    if (user?.isCN)
      return {
        plantId: userAny?.plantCode,
        implementationDate: dayjs(),
        ...(user?.isQLD && { managerId: user.id }),
      };
    if (user?.isSale) {
      const teamSale = userAny?.teamSales?.[0];
      return {
        plantId: userAny?.plantCode,
        teamSaleId: teamSale?.id || null,
        implementationDate: dayjs(),
      };
    }
    if (user?.isAdmin || user?.isHO) {
      return { implementationDate: dayjs(), plantId: '5001' };
    }
    return { implementationDate: dayjs() };
  }, [user]);

  const {
    data: dataTeamSaleTracking,
    isPending: isLoadingTeamSaleTracking,
    mutate: getTeamSaleTracking,
  } = useMutation({
    mutationFn: RouteTrackingApi.getTeamSaleByFilter,
    onSuccess: (res) => {
      // console.log(res);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    data: dataLocationTeamSale,
    isPending: isLoadingLocationTeamSale,
    mutate: getLocationTeamSale,
  } = useMutation({
    mutationFn: RouteTrackingApi.getLocationTeamSaleByPlant,
    onSuccess: (res) => {
      // console.log('dataLocationTeamSale', res);
      setLocationCustoms([]);
      setLocationTeams(res?.data?.getLocationTeamSaleByPlant?.tteamSale);
      setIsShowMapCustom(false);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  // GetLocationTeamSaleInPlantByTeamSale
  const {
    data: dataLocationCustomebyTeamSale,
    isPending: isLoandingLocationCustomebyTeamSale,
    mutate: getLocationCustomebyTeamSale,
  } = useMutation({
    mutationFn: RouteTrackingApi.getLocationTeamSaleInPlantByTeamSale,
    onSuccess: (res) => {
      // console.log('dataLocationCustomebyTeamSale res ', res);
      setLocationTeams([]);
      // setLocationCustoms(
      //   dataTestLocationCustomebyTeamSale?.data
      //     ?.getLocationTeamSaleInPlantByTeamSale,
      // );
      setLocationCustoms(res?.data?.getLocationTeamSaleInPlantByTeamSale);
      setIsShowMapCustom(true);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    setTitle('');
    setBreadcrumb([]);
    setSalePlanningId(null);
    getTeamSaleTracking({
      page,
      page_size,
      ...defaultFilter,
      ...dataFilter,
      ...(defaultFilter.teamSaleId === null && { teamSaleId: null }),
    });
    getLocationTeamSale({
      page,
      page_size,
      ...defaultFilter,
      ...dataFilter,
      ...(defaultFilter.teamSaleId === null && { teamSaleId: null }),
    });
  }, [dataFilter, page, page_size]);

  useEffect(() => {
    if (salePlanningId) {
      getLocationCustomebyTeamSale({
        salePlanningId,
        ...defaultFilter,
        ...dataFilter,
      });
    }
  }, [salePlanningId]);

  const handleSeachFilter = (value: any) => {
    setIsShowMapCustom(false);
    setDataFilter(value);
    navigate(`${path.ROUTE_TRACKING}?page=1&page_size=${page_size}`);
  };

  const handleClickRow = useCallback((record: any) => {
    // console.log(record);
    // setIsShowMapCustom(true);
    setSalePlanningId(record?.salePlanningId);
  }, []);

  const handleUpdate = () => {
    if (isShowMapCustom) {
      getLocationCustomebyTeamSale({
        salePlanningId,
        ...defaultFilter,
        ...dataFilter,
      });
    } else {
      getTeamSaleTracking({ page, page_size, ...defaultFilter, ...dataFilter });
      getLocationTeamSale({
        page,
        page_size,
        ...defaultFilter,
        ...dataFilter,
      });
    }
  };

  return (
    <Space direction="vertical">
      <Row className="mt-3" gutter={15}>
        {/* Left */}
        <Col className="w-[35%]">
          <Flex vertical gap={6}>
            {/* Top left */}
            <Space direction="vertical" size={0} className="h-[73px] mb-3">
              <Text className="text-[#003056] font-bold text-2xl">
                Giám sát lộ trình nhân viên
              </Text>
              <ConfigProvider
                theme={{
                  components: {
                    Breadcrumb: {
                      lastItemColor: '#003056',
                    },
                  },
                }}
              >
                <Breadcrumb
                  items={[
                    { title: 'Giám sát' },
                    { title: 'Giám sát lộ trình nhân viên' },
                  ]}
                />
              </ConfigProvider>
            </Space>

            <Row gutter={10} justify={'end'}>
              <Col>
                <ButtonFilter isOpen={isOpen} setIsOpen={setIsOpen} />
              </Col>
              <Col>
                <Button
                  fill
                  title="Cập nhật"
                  iconBefore={<IconLoading />}
                  handleOnclick={handleUpdate}
                />
              </Col>
            </Row>

            <FilterEmployeeRouteTracking
              isOpen={isOpen}
              defaultFilter={defaultFilter}
              // onCancel={handleCancelFilter}
              onSearch={handleSeachFilter}
            />

            {/* <TableEmployeeRouteTracking /> */}
            <TableEmployeeRouteTracking
              data={dataTeamSaleTracking?.data?.getSalePlanningByTeam}
              loading={isLoadingTeamSaleTracking || isLoadingLocationTeamSale}
              onClickRow={handleClickRow}
              selectedRowKey={salePlanningId}
              isShowMapCustom={isShowMapCustom}
            />
          </Flex>
        </Col>

        {/* Right */}
        <Col className="w-[65%]">
          <Flex vertical gap={6} className="h-full">
            <div className={`max-w-full overflow-x-auto`}>
              <Flex justify="space-between" gap={5} className="h-[63px] mb-3">
                {isShowMapCustom ? (
                  <>
                    <div className="w-[10%] min-w-max">
                      <TitleValueItem
                        title="Mã đội"
                        value={
                          dataLocationCustomebyTeamSale?.data
                            ?.getLocationTeamSaleInPlantByTeamSale
                            ?.teamSalesSubId || '-'
                        }
                        isLoading={isLoandingLocationCustomebyTeamSale}
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng doanh thu"
                        value={
                          <>
                            {formatNumber(
                              dataLocationCustomebyTeamSale?.data
                                ?.getLocationTeamSaleInPlantByTeamSale
                                ?.expectedRevenue || 0,
                            )}
                            <TextCustom
                              value={`(${
                                dataLocationCustomebyTeamSale?.data
                                  ?.getLocationTeamSaleInPlantByTeamSale
                                  ?.radioExpectedRevenues || 0
                              }%)`}
                              lineHeight="leading-4"
                              className="text-xs"
                              color="green"
                              size="sm"
                            />
                          </>
                        }
                        isLoading={isLoandingLocationCustomebyTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng công"
                        value={
                          dataLocationCustomebyTeamSale?.data
                            ?.getLocationTeamSaleInPlantByTeamSale
                            ?.totalProcessPriceSap || 0
                        }
                        isLoading={isLoandingLocationCustomebyTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng doanh thu công"
                        value={
                          dataLocationCustomebyTeamSale?.data
                            ?.getLocationTeamSaleInPlantByTeamSale
                            ?.totalProcessPrice || 0
                        }
                        isLoading={isLoandingLocationCustomebyTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng doanh thu món"
                        value={
                          dataLocationCustomebyTeamSale?.data
                            ?.getLocationTeamSaleInPlantByTeamSale
                            .totalProductPrice || 0
                        }
                        isLoading={isLoandingLocationCustomebyTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="flex-1 min-w-36">
                      <TitleValueItem
                        title="Tổng khách hàng"
                        value={
                          <>
                            {dataLocationCustomebyTeamSale?.data
                              ?.getLocationTeamSaleInPlantByTeamSale
                              .totalCaseCustomer || 0}
                            <TextCustom
                              value={`/${
                                dataLocationCustomebyTeamSale?.data
                                  ?.getLocationTeamSaleInPlantByTeamSale
                                  .totalCustomer || 0
                              }`}
                              className="text-xs"
                              title
                            />
                          </>
                        }
                        isLoading={isLoandingLocationCustomebyTeamSale}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-[10%] min-w-max">
                      <TitleValueItem
                        title="Tổng đội"
                        value={
                          dataLocationTeamSale?.data?.getLocationTeamSaleByPlant
                            ?.totalTeamSale || '-'
                        }
                        isLoading={isLoadingLocationTeamSale}
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng doanh thu"
                        value={
                          <>
                            {formatNumber(
                              dataLocationTeamSale?.data
                                ?.getLocationTeamSaleByPlant?.revenueRealized ||
                                0,
                            )}
                            <TextCustom
                              value={`(${
                                dataLocationTeamSale?.data
                                  ?.getLocationTeamSaleByPlant
                                  ?.ratioRevenueRealized || 0
                              }%)`}
                              className="text-xs"
                              lineHeight="leading-4"
                              color="green"
                              size="sm"
                            />
                          </>
                        }
                        isLoading={isLoadingLocationTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng công"
                        value={
                          dataLocationTeamSale?.data?.getLocationTeamSaleByPlant
                            ?.totalProcessPriceSap || 0
                        }
                        isLoading={isLoadingLocationTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng doanh thu công"
                        value={
                          dataLocationTeamSale?.data?.getLocationTeamSaleByPlant
                            ?.totalProcessPrice || 0
                        }
                        isLoading={isLoadingLocationTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="w-[25%] min-w-max">
                      <TitleValueItem
                        title="Tổng doanh thu món"
                        value={
                          dataLocationTeamSale?.data?.getLocationTeamSaleByPlant
                            .totalProductPrice || 0
                        }
                        isLoading={isLoadingLocationTeamSale}
                        isNumber
                      />
                    </div>
                    <div className="flex-1 min-w-36">
                      <TitleValueItem
                        title="Tổng khách hàng"
                        value={
                          <>
                            {dataLocationTeamSale?.data
                              ?.getLocationTeamSaleByPlant.totalCaseCustomer ||
                              0}
                            <TextCustom
                              value={`/${
                                dataLocationTeamSale?.data
                                  ?.getLocationTeamSaleByPlant.totalCustomer ||
                                0
                              }`}
                              className="text-xs"
                              title
                            />
                          </>
                        }
                        isLoading={isLoadingLocationTeamSale}
                      />
                    </div>
                  </>
                )}
              </Flex>
            </div>

            <div
              // className="border-[#0077CC] border-4"
              style={{ height: 'calc(100vh - 163px)' }}
            >
              <GoogleMap
                listLocationTeam={locationTeams}
                listLocationCustom={locationCustoms}
                isShowMapCustom={isShowMapCustom}
              />
            </div>
          </Flex>
        </Col>
      </Row>
    </Space>
  );
};

export default EmployeeRouteTracking;

interface TitleValueItemProps {
  title: string;
  value: any;
  isLoading: boolean;
  isNumber?: boolean;
}

const TitleValueItem = (props: TitleValueItemProps) => {
  const { title, value, isLoading, isNumber = false } = props;
  return isNumber ? (
    <Spin spinning={isLoading}>
      <Flex
        className="bg-white rounded-lg shadow-md p-3"
        justify="center"
        vertical
        gap={4}
      >
        <TextCustom value={title} className="text-xs" />
        <Row justify={'space-between'} align={'bottom'} className="min-w-36">
          <TextCustom value={value} title className="text-xs" isNumber />
          <TextCustom
            value={'VND'}
            className="!ml-1 text-xs"
            lineHeight="leading-4"
          />
        </Row>
      </Flex>
    </Spin>
  ) : (
    <Spin spinning={isLoading}>
      <Flex
        className="bg-white rounded-lg shadow-md p-3"
        justify="center"
        vertical
        gap={4}
      >
        <TextCustom value={title} className="text-xs" />
        <TextCustom value={value} className="text-xs" title color={'blue'} />
      </Flex>
    </Spin>
  );
};
